import '../css/app.css'
import './bootstrap'
import { createInertiaApp, router } from '@inertiajs/vue3'
import { createApp, h } from 'vue'
import { identifyVisitor } from './composables/useAnalytics'

// Sync CSRF token meta tag on each Inertia navigation
router.on('navigate', (event) => {
  const csrfToken = event.detail.page.props.csrf_token
  if (csrfToken) {
    const meta = document.querySelector('meta[name="csrf-token"]')
    if (meta) {
      meta.setAttribute('content', csrfToken)
    }
  }

  identifyVisitor(event.detail.page.props.auth?.user)
})

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('./Pages/**/*.vue', { eager: true })
    return pages[`./Pages/${name}.vue`]
  },
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .mount(el)

    identifyVisitor(props.initialPage.props.auth?.user)
  },
})
